import React from 'react'

export const CrossIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--cross'
    viewBox='0 0 32 32'
  >
    <path
      d='M27.1,28.1c-0.3,0-0.5-0.1-0.7-0.3L4.2,5.6c-0.3-0.3-0.3-0.9,0-1.4c0.3-0.3,0.9-0.3,1.4,0l22.3,22.3c0.3,0.3,0.3,0.9,0,1.4C27.7,28,27.4,28.1,27.1,28.1z'
    />
    <path
      d='M4.9,28.1c-0.3,0-0.5-0.1-0.7-0.3c-0.3-0.3-0.3-0.9,0-1.4L26.4,4.2c0.3-0.3,0.9-0.3,1.4,0c0.3,0.3,0.3,0.9,0,1.4L5.6,27.8C5.4,28,5.1,28.1,4.9,28.1z'
    />
  </svg>
)
